import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { SeoPageLayout } from '@/components/layout/SeoPageLayout';
import { Button, FAQs, MinorHeader, Paragraph, SemiBold, SubHeader, UnorderedList } from '@/components/seo';
import { LINKS } from '@/constants/links';
import { isAllowedRoute } from '@/lang/pagesConfig';
import { NumericRange } from '@/types/range';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
import { Link } from '@/components/links';
import { LinkableBanner } from '@/components/seo/LinkableBanner';
interface Props extends IntlProps {
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(119);
  const {
    menuPromoBanners
  } = t0;
  usePageView("seo-loans");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["seoLoans", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = Array.from({
      length: 6
    }, (_, index) => {
      const faqIndex = index + 1 as NumericRange<1, 6>;
      return {
        question: t(`seoLoans:sections.faqs.${faqIndex}.question`),
        answer: t(`seoLoans:sections.faqs.${faqIndex}.answer`)
      };
    });
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const faqsData = t2;
  let t3;
  if ($[3] !== t) {
    t3 = t("seoLoans:seo.title");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("seoLoans:seo.description");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = {
      title: t3,
      description: t4
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  let t8;
  if ($[11] !== t) {
    t7 = <Trans t={t} i18nKey="seoLoans:header.title">{t6}</Trans>;
    t8 = t("seoLoans:header.intro");
    $[11] = t;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <p>{t8}</p>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t) {
    t10 = t("seoLoans:header.button");
    $[16] = t;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = LINKS();
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10) {
    t12 = {
      label: t10,
      to: t11.loan
    };
    $[19] = t10;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t) {
    t13 = t("seoLoans:sections.1.title");
    $[21] = t;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t) {
    t15 = <Trans t={t} i18nKey="seoLoans:sections.1.content" components={t14} />;
    $[24] = t;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t13 || $[27] !== t15) {
    t16 = {
      title: t13,
      content: t15
    };
    $[26] = t13;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t) {
    t17 = t("seoLoans:sections.2.title");
    $[29] = t;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = [...Array(3)];
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t) {
    t19 = <>{t18.map((__0, i) => {
        const transIndex = i + 1 as NumericRange<1, 3>;
        return <Trans key={i} t={t} i18nKey={`seoLoans:sections.2.subsections.${transIndex}`} components={{
          paragraph: <Paragraph />,
          subheader: <SubHeader />,
          minorheader: <MinorHeader />,
          semibold: <SemiBold />,
          linkLoan: <Link to={LINKS().loan} testId="loanInfo" analyticsParam="loanInfo" />,
          banner: <LinkableBanner to={LINKS().loan} src="/images/sections/loans/cs/1.png" width={1536} height={636} testId="loanPromoBanner" analyticsParam="loanPromoBanner" alt={t("seoLoans:sections.2.subsections.2")} />
        }} />;
      })}</>;
    $[32] = t;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t17 || $[35] !== t19) {
    t20 = {
      title: t17,
      content: t19
    };
    $[34] = t17;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t) {
    t21 = t("seoLoans:sections.3.title");
    $[37] = t;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t) {
    t23 = <Trans t={t} i18nKey="seoLoans:sections.3.content1" components={t22} />;
    $[40] = t;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = {
      subheader: <SubHeader />
    };
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  if ($[43] !== t) {
    t25 = <Trans t={t} i18nKey="seoLoans:sections.3.content2" components={t24} />;
    $[43] = t;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = [...Array(5)];
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] !== t) {
    t27 = <UnorderedList items={t26.map((__1, i_0) => {
      const transIndex_0 = i_0 + 1 as NumericRange<1, 5>;
      return <Trans key={i_0} t={t} i18nKey={`seoLoans:sections.3.list.${transIndex_0}`} />;
    })} className="mt-2 mb-8" />;
    $[46] = t;
    $[47] = t27;
  } else {
    t27 = $[47];
  }
  let t28;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] !== t) {
    t29 = <Trans t={t} i18nKey="seoLoans:sections.3.content3" components={t28} />;
    $[49] = t;
    $[50] = t29;
  } else {
    t29 = $[50];
  }
  let t30;
  if ($[51] !== t23 || $[52] !== t25 || $[53] !== t27 || $[54] !== t29) {
    t30 = <>{t23}{t25}{t27}{t29}</>;
    $[51] = t23;
    $[52] = t25;
    $[53] = t27;
    $[54] = t29;
    $[55] = t30;
  } else {
    t30 = $[55];
  }
  let t31;
  if ($[56] !== t21 || $[57] !== t30) {
    t31 = {
      title: t21,
      content: t30
    };
    $[56] = t21;
    $[57] = t30;
    $[58] = t31;
  } else {
    t31 = $[58];
  }
  let t32;
  if ($[59] !== t) {
    t32 = t("seoLoans:sections.4.title");
    $[59] = t;
    $[60] = t32;
  } else {
    t32 = $[60];
  }
  let t33;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[61] = t33;
  } else {
    t33 = $[61];
  }
  let t34;
  if ($[62] !== t) {
    t34 = <Trans t={t} i18nKey="seoLoans:sections.4.content" components={t33} />;
    $[62] = t;
    $[63] = t34;
  } else {
    t34 = $[63];
  }
  let t35;
  if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = [...Array(4)];
    $[64] = t35;
  } else {
    t35 = $[64];
  }
  let t36;
  if ($[65] !== t) {
    t36 = t35.map((__2, i_1) => {
      const transIndex_1 = i_1 + 1 as NumericRange<1, 4>;
      return <Trans key={i_1} t={t} i18nKey={`seoLoans:sections.4.subsections.${transIndex_1}`} components={{
        paragraph: <Paragraph />,
        subheader: <SubHeader />,
        minorheader: <MinorHeader />,
        semibold: <SemiBold />,
        linkLoan: <Link to={LINKS().loan} testId="loanInfo" analyticsParam="loanInfo" />
      }} />;
    });
    $[65] = t;
    $[66] = t36;
  } else {
    t36 = $[66];
  }
  let t37;
  if ($[67] !== t34 || $[68] !== t36) {
    t37 = <>{t34}{t36}</>;
    $[67] = t34;
    $[68] = t36;
    $[69] = t37;
  } else {
    t37 = $[69];
  }
  let t38;
  if ($[70] !== t32 || $[71] !== t37) {
    t38 = {
      title: t32,
      content: t37
    };
    $[70] = t32;
    $[71] = t37;
    $[72] = t38;
  } else {
    t38 = $[72];
  }
  let t39;
  if ($[73] !== t) {
    t39 = t("seoLoans:sections.5.title");
    $[73] = t;
    $[74] = t39;
  } else {
    t39 = $[74];
  }
  let t40;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[75] = t40;
  } else {
    t40 = $[75];
  }
  let t41;
  if ($[76] !== t) {
    t41 = <Trans t={t} i18nKey="seoLoans:sections.5.content" components={t40} />;
    $[76] = t;
    $[77] = t41;
  } else {
    t41 = $[77];
  }
  let t42;
  if ($[78] !== t39 || $[79] !== t41) {
    t42 = {
      title: t39,
      content: t41
    };
    $[78] = t39;
    $[79] = t41;
    $[80] = t42;
  } else {
    t42 = $[80];
  }
  let t43;
  if ($[81] !== t) {
    t43 = t("seoLoans:sections.6.title");
    $[81] = t;
    $[82] = t43;
  } else {
    t43 = $[82];
  }
  let t44;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = {
      paragraph: <Paragraph />,
      semibold: <SemiBold />
    };
    $[83] = t44;
  } else {
    t44 = $[83];
  }
  let t45;
  if ($[84] !== t) {
    t45 = <Trans t={t} i18nKey="seoLoans:sections.6.content" components={t44} />;
    $[84] = t;
    $[85] = t45;
  } else {
    t45 = $[85];
  }
  let t46;
  if ($[86] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = LINKS();
    $[86] = t46;
  } else {
    t46 = $[86];
  }
  const t47 = t46.whereToShop;
  let t48;
  if ($[87] !== t) {
    t48 = t("seoLoans:sections.6.button");
    $[87] = t;
    $[88] = t48;
  } else {
    t48 = $[88];
  }
  let t49;
  if ($[89] !== t48) {
    t49 = <Button analyticsParam="linkWhereToShop" testId="linkWhereToShop" to={t47} variant="primary">{t48}</Button>;
    $[89] = t48;
    $[90] = t49;
  } else {
    t49 = $[90];
  }
  let t50;
  if ($[91] !== t45 || $[92] !== t49) {
    t50 = <>{t45}{t49}</>;
    $[91] = t45;
    $[92] = t49;
    $[93] = t50;
  } else {
    t50 = $[93];
  }
  let t51;
  if ($[94] !== t43 || $[95] !== t50) {
    t51 = {
      title: t43,
      content: t50
    };
    $[94] = t43;
    $[95] = t50;
    $[96] = t51;
  } else {
    t51 = $[96];
  }
  let t52;
  if ($[97] !== faqsData) {
    t52 = <FAQs data={faqsData} />;
    $[97] = faqsData;
    $[98] = t52;
  } else {
    t52 = $[98];
  }
  let t53;
  if ($[99] !== t) {
    t53 = t("core:faqs.title");
    $[99] = t;
    $[100] = t53;
  } else {
    t53 = $[100];
  }
  let t54;
  if ($[101] !== t52 || $[102] !== t53) {
    t54 = {
      content: t52,
      title: t53
    };
    $[101] = t52;
    $[102] = t53;
    $[103] = t54;
  } else {
    t54 = $[103];
  }
  let t55;
  if ($[104] !== t16 || $[105] !== t20 || $[106] !== t31 || $[107] !== t38 || $[108] !== t42 || $[109] !== t51 || $[110] !== t54) {
    t55 = [t16, t20, t31, t38, t42, t51, t54];
    $[104] = t16;
    $[105] = t20;
    $[106] = t31;
    $[107] = t38;
    $[108] = t42;
    $[109] = t51;
    $[110] = t54;
    $[111] = t55;
  } else {
    t55 = $[111];
  }
  let t56;
  if ($[112] !== menuPromoBanners || $[113] !== t12 || $[114] !== t5 || $[115] !== t55 || $[116] !== t7 || $[117] !== t9) {
    t56 = <SeoPageLayout menuPromoBanners={menuPromoBanners} seo={t5} title={t7} intro={t9} introButton={t12} sections={t55} />;
    $[112] = menuPromoBanners;
    $[113] = t12;
    $[114] = t5;
    $[115] = t55;
    $[116] = t7;
    $[117] = t9;
    $[118] = t56;
  } else {
    t56 = $[118];
  }
  return t56;
}
export const getStaticProps: GetStaticProps = async ctx => {
  const isAllowed = isAllowedRoute('pujcky');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...(await getIntlProps(ctx, ['core', 'seoLoans']))
    }
  };
};